<template>
    <div>
        <h1 class="display-heading">Payment Details</h1>

        <div class="card mb-5">
            <div class="card-header d-flex justify-content-between align-items-baseline">
                <span>Prescription List</span>
                <button class="btn btn-info btn-info-insv" type="button" @click="viewPatientPastPrescriptions">
                    View Patient Past Prescriptions
                </button>
            </div>
            <div class="card-body">
                <!-- <prescription-detail :isEdit="editPrescription" v-model="prescriptionList">
                </prescription-detail> -->
                <prescription-detail :isEdit="isEditPrescription" v-model="prescriptionList"
                    :pharmacyId="pharmacyId" :drugType="2">
                    <!-- <template v-if="prescriptionList.length> 0">
                            <form data-vv-scope="prescription-valid-days" @submit.prevent="validatePrescriptionValidDays">
                                <div id="prescription" class="d-flex align-items-baseline">
                                    <label class="mr-2 mb-0">{{ isEditPrescription ? "Prescription Valid for (Days):" : "Prescription valid until"}}  </label>
                                    <input name="prescriptionValidDays" type="text"
                                        v-if="isEditPrescription"
                                        data-vv-validate-on="blur" data-vv-as="prescription valid"
                                        v-validate="'required|numeric|min_value:1'"
                                        v-model="prescriptionValidDays" :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('prescription-valid-days.prescriptionValidDays')
                                    }">
                                    <div v-else>
                                        {{prescriptionValidUntil ? convertToUserReadableDate(prescriptionValidUntil): '-'}}
                                    </div>
                                </div>
                            </form>
                    </template> -->
                </prescription-detail>

                <div v-if="saveErrorMessage" class="text-danger font-sm">{{ saveErrorMessage }}</div>
                <button v-if="!isEditPrescription" class="btn btn-primary btn-primary-insv mt-2" type="button" @click="editPrescription">
                    Edit
                </button>
                <div v-else class="mt-2">
                    <button class="btn btn-danger btn-danger-insv" type="button" @click="cancelEditPrescription">
                        Cancel
                    </button>
                    <button class="btn btn-primary btn-primary-insv ml-2" type="button" @click="savePrescription">
                        Save
                    </button>
                </div>
            </div>
        </div>

        <div class="card mb-5">
            <div class="card-header">Payment Summary</div>
            <div class="card-body">
               <table class="table table-bordered table-sm">
                    <colgroup>
                        <col width="70">
                        <col>
                        <col width="130">
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Item</th>
                            <th scope="col" class="text-right">Price (RM)</th>
                        </tr>
                    </thead>
                    <tbody v-for="(item, index) in paymentSummaryItems" :key="index">
                        <tr>
                            <th scope="row">{{index+1}}</th>
                            <td>{{item.itemName}} {{ item.itemDescription ? `- ${item.itemDescription}` : null }}</td>
                            <td class="text-right">{{item.itemPrice.toFixed(2)}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <th colspan="2" scope="row" class="text-right">Total (RM)</th>
                        <td class="text-right">
                            {{paymentSummaryTotal.toFixed(2)}}
                        </td>
                    </tfoot>
                </table>
            </div>
        </div>

        <div class="card">
            <div class="card-header">Collect Payment</div>
            <div class="card-body">
                <div class="payment-detail">
                    <div class="payment-detail-row">
                        <div class="payment-detail-title">
                            <b>Patient Name</b>
                        </div>
                        <div class="payment-detail-content">
                            {{collectPaymentDetails.name}}
                        </div>
                    </div>

                    <div class="payment-detail-row">
                        <div class="payment-detail-title">
                            <b>Patient IC Number</b>
                        </div>
                        <div class="payment-detail-content">
                            {{collectPaymentDetails.icNumber}}
                        </div>
                    </div>

                    <div class="payment-detail-row">
                        <div class="payment-detail-title">
                            <b>Enrolled in Company</b>
                        </div>
                        <div class="payment-detail-content">
                            {{collectPaymentDetails.isCompanyEmployee ? 'Yes': 'No'}}
                        </div>
                    </div>

                    <template v-if="collectPaymentDetails.isCompanyEmployee" class="card">
                        <div v-for="(companyBenefit, index) in companyBenefitDetails" :key="index" :class="['card', {
                            'mb-3': index != companyBenefitDetails.length - 1
                        }]">
                            <div  class="card-body">
                                <div class="payment-detail-row">
                                    <div class="payment-detail-title">
                                        <b>Benefit Principal Name</b>
                                    </div>
                                    <div class="payment-detail-content">
                                        {{companyBenefit.benefitPrincipal}}
                                    </div>
                                </div>

                                <div class="payment-detail-row">
                                    <div class="payment-detail-title">
                                        <b>Company Name</b>
                                    </div>
                                    <div class="payment-detail-content">
                                        {{companyBenefit.companyName}}
                                    </div>
                                </div>

                                <div class="payment-detail-row">
                                    <div class="payment-detail-title">
                                        <b>Benefit Type</b>
                                    </div>
                                    <div class="payment-detail-content">
                                        {{relationshipTypes.find(r => r.value == companyBenefit.benefitType).text}}
                                    </div>
                                </div>

                                <template v-if="companyBenefit.collectEmployeeCreditAmount > 0">
                                    <div class="payment-detail-row">
                                        <div class="payment-detail-title">
                                            <b>Employee Credit Charges (RM)</b>
                                        </div>
                                        <div class="payment-detail-content">
                                            {{companyBenefit.collectEmployeeCreditAmount.toFixed(2)}}
                                        </div>
                                    </div>

                                    <div class="payment-detail-row">
                                        <div class="payment-detail-title">
                                            <b>Clinic Collection Amount (RM)</b>
                                        </div>
                                        <div class="payment-detail-content">
                                            <b>{{companyBenefit.counterCollectAmount.toFixed(2)}}</b>
                                        </div>
                                    </div>

                                    <div class="payment-detail-row">
                                        <div class="payment-detail-title">
                                            <b>Remarks</b>
                                        </div>
                                        <div class="payment-detail-content">
                                            {{companyBenefit.remark}}
                                        </div>
                                    </div>

                                </template>
                                <template v-else>
                                    <div class="payment-detail-row">
                                        <div class="payment-detail-title">
                                            <b>Clinic Collection Amount (RM)</b>
                                        </div>
                                        <div class="payment-detail-content">
                                            <b>{{companyBenefit.counterCollectAmount.toFixed(2)}}</b>
                                        </div>
                                    </div>

                                    <div class="payment-detail-row">
                                        <div class="payment-detail-title">
                                            <b>Remarks</b>
                                        </div>
                                        <div class="payment-detail-content">
                                            {{companyBenefit.remark}} Please collect full amount from patient.
                                        </div>
                                    </div>
                                </template>

                                <button class="btn btn-primary btn-primary-insv" type="button" @click="completePayment(companyBenefit.employeeTierId)">
                                    {{ companyBenefit.collectEmployeeCreditAmount > 0 ? "Deduct Credit Balance" : "Mark Consultation As Payment Collected" }}
                                </button>
                            </div>
                        </div>
                    </template>

                    <div v-else class="mb-3">
                        <div class="payment-detail-row">
                            <div class="payment-detail-title">
                                <b>Remarks</b>
                            </div>
                            <div class="payment-detail-content">
                                Please collect full amount from patient.
                            </div>
                        </div>
                        <button class="btn btn-primary btn-primary-insv mt-3" type="button" @click="completePayment(null)">
                            Mark Consultation As Payment Collected
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Edit prescription Pop Up -->
        <popup-modal ref="popupCollectPayment" :hasCloseButton="false" :title="isEditPrescription ? 'Pending Prescription Changes!' : 'Mark Consultation As Paid'">
            <template slot="content">
                <div v-html="confirmMarkAsPaidMessage"></div>
            </template>
            <template v-if="!isEditPrescription" slot="footer">
                <template v-if="!isSubmittingCompletePayment && !isFailedCompletePayment">
                    <button type="button" class="btn btn-primary btn-primary-insv" @click="confirmProceed" :disabled="countdown > 0">Confirm {{ countdown > 0 ? `(${countdown}s)` : '' }}</button>
                    <button type="button" class="btn btn-secondary" @click="dismissConfirmPayment">Cancel</button>
                </template>
                <button v-if="isSuccessSubmitCompletePayment" class="button btn btn-primary btn-primary-insv" type="button" @click="redirectToPaymentPage">
                    Okay
                </button>
                <button v-if="isFailedCompletePayment" class="button btn btn-primary btn-primary-insv" @click="dismissConfirmPayment">Review Payment</button>
            </template>
            <template v-else slot="footer">
                <template v-if="!isSubmittingCompletePayment && !isFailedCompletePayment">
                    <button type="button" class="btn btn-primary btn-primary-insv" @click="discardPrescriptionChanges" :disabled="countdown > 0">Discard changes and Proceed {{ countdown > 0 ? `(${countdown}s)` : '' }}</button>
                    <button type="button" class="btn btn-secondary" @click="dismissConfirmPayment">Cancel</button>
                </template>
            </template>
        </popup-modal>

        <popup-modal ref="savingPrescription" :hasCloseButton="false" title="Saving New Prescription">
            <template slot="content">
                <div>Saving new prescription and calculating payment, please wait...</div>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import popupModal from '@/components/popup-modal';
import prescriptionDetail from '@/components/prescription';
import relationshipTypes from '@/config/relationshipTypes';
import {
    convertToUserReadableDate,
    constructPrescriptionList
} from '@/utilities';
import _ from 'lodash';

export default {
    'name': 'ClinicPaymentDetails',
    'components': {
        prescriptionDetail,
        popupModal
    },
    'computed': {
        clinicPaymentId () {
            return this.$route.params.clinicPaymentId;
        }
    },
    data () {
        return {
            convertToUserReadableDate,
            'prescriptionList': [],
            'oldPrescriptionList': [],
            'isEditPrescription': false,
            'paymentSummaryTotal': 0,
            'paymentSummaryItems': [],
            'collectPaymentDetails': {
                'name': null,
                'icNumber': null,
                'isCompanyEmployee': false,
                'patientId': null,
                'counterCollectAmount': 0
            },
            'companyBenefitDetails': [],
            'selectedEmployeeTierId': '',
            'collectEmployeeCreditAmount': 0,
            'confirmMarkAsPaidMessage': '',
            'isSubmittingCompletePayment': false,
            'isSuccessSubmitCompletePayment': false,
            'isFailedCompletePayment': false,
            'pharmacyId': 'c790b8e8-a595-11ea-a7bf-00163e000d23',
            'prescriptionValidDays': 0,
            'prescriptionValidUntil': null,
            'saveErrorMessage': null,
            relationshipTypes,
            'countdown': 10,
            'countdownTimer': null
        };
    },
    mounted () {
        this.getPaymentDetails();
    },
    'methods': {
        getPaymentDetails () {
            this.axios
                .post('Clinic/GetClinicPayment', {
                    'clinicPaymentId': this.clinicPaymentId
                })
                .then(({ data }) => {
                    let payment = data.data.payment;
                    let prescription = data.data.prescription;
                    let collectPaymentDetails = data.data.collectPaymentDetails;
                    let companyBenefitDetails = data.data.companyBenefitDetails;
                    if (prescription.pil) {
                        this.prescriptionList = constructPrescriptionList(prescription.pil);
                    }
                    if (payment) {
                        this.initializePaymentSummary(payment);
                    }
                    if (collectPaymentDetails) {
                        this.initiateCollectPaymentDetails(collectPaymentDetails);
                    }
                    if (companyBenefitDetails.length > 0) {
                        this.initiateCompanyBenefitDetails(companyBenefitDetails);
                    }
                    if (prescription.vu) {
                        this.prescriptionValidUntil = prescription.vu;
                    }
                });
        },
        initializePaymentSummary (paymentSummary) {
            this.paymentSummaryTotal = paymentSummary.am;

            this.paymentSummaryItems = paymentSummary.psi.map((item) => ({
                'itemName': item.in,
                'itemType': item.it,
                'itemDescription': item.id,
                'itemPrice': item.ip
            }));
        },
        initiateCollectPaymentDetails (collectPaymentDetails) {
            this.collectPaymentDetails.name = collectPaymentDetails.name;
            this.collectPaymentDetails.icNumber = collectPaymentDetails.icNumber;
            this.collectPaymentDetails.isCompanyEmployee = collectPaymentDetails.isCompanyEmployee;
            this.collectPaymentDetails.patientId = collectPaymentDetails.patientId;
            this.collectPaymentDetails.counterCollectAmount = collectPaymentDetails.counterCollectAmount;
        },
        initiateCompanyBenefitDetails (companyBenefitDetails) {
            this.companyBenefitDetails = companyBenefitDetails.map((item) => ({
                'benefitPrincipal': item.benefitPrincipal,
                'companyName': item.companyName,
                'benefitType': item.benefitType,
                'employeeTierId': item.employeeTierId,
                'companyCreditInsufficient': item.companyCreditInsufficient,
                'needOffsetPayment': item.needOffsetPayment,
                'collectEmployeeCreditAmount': item.collectEmployeeCreditAmount,
                'counterCollectAmount': item.counterCollectAmount,
                'remark': item.remark,
                'icdCodeOrProcedureCodeNotCovered': item.icdCodeOrProcedureCodeNotCovered,
                'isIcdCodeCovered': item.isIcdCodeCovered,
                'isProcedureCodeCovered': item.isProcedureCodeCovered
                // 'canMakePaymentWithCompanyCredit': item.canMakePaymentWithCompanyCredit,
                // 'employeeCurrentSpending': item.employeeCurrentSpending,
                // 'employeeSpendingLimit': item.employeeSpendingLimit,
                // 'hasEmployeeClinicConsultationTransactionLimit': item.hasEmployeeClinicConsultationTransactionLimit,
                // 'employeeClinicConsultationTransactionLimit': item.employeeClinicConsultationTransactionLimit,
                // 'employeeCreditOverlimitPerTransaction': item.employeeCreditOverlimitPerTransaction,
                // 'employeeSpendingOverlimit': item.employeeSpendingOverlimit
            }));
        },
        popUpCompletePayment () {

        },
        completePayment (employeeTierId) {
            this.isFailedCompletePayment = false;
            this.selectedEmployeeTierId = employeeTierId;

            const selectedCompanyBenefitToProceed = this.companyBenefitDetails.find(c => c.employeeTierId === employeeTierId);

            this.collectEmployeeCreditAmount = selectedCompanyBenefitToProceed ? selectedCompanyBenefitToProceed.collectEmployeeCreditAmount : 0;
            let counterCollectAmount = selectedCompanyBenefitToProceed ? selectedCompanyBenefitToProceed.counterCollectAmount : this.collectPaymentDetails.counterCollectAmount;

            if (this.countdownTimer) {
                clearInterval(this.countdownTimer);
            }

            this.countdown = 10;
            this.countdownTimer = setInterval(() => {
                this.countdown--;
                if (this.countdown === 0) {
                    clearInterval(this.countdownTimer);
                }
            }, 1000);

            let collectMessageAppendText = '';
            const instructionText = `<hr>Note: Please advise patient to check the granted benefits set by their company HR through the Health Savvy Mobile App. <br> Steps: 
            <ol>
                <li>From the main menu, go to <b>Company Credit Balance</b> page.</li>
                <li>Click on <b>View Benefits</b> button.</li>
            </ol><br>Please advise patient to pay cash in 100% and seek reimbursement from their company HR (if applicable).`;

            if (selectedCompanyBenefitToProceed) {
                if (counterCollectAmount > 0) {
                    if (selectedCompanyBenefitToProceed.icdCodeOrProcedureCodeNotCovered) {
                        if (!selectedCompanyBenefitToProceed.isIcdCodeCovered && !selectedCompanyBenefitToProceed.isProcedureCodeCovered) {
                            collectMessageAppendText = `Consultation diagnosis and MMA Procedure(s) are not covered in patient's benefits.<br />${instructionText}`;
                        } else if (!selectedCompanyBenefitToProceed.isIcdCodeCovered) {
                            collectMessageAppendText = `One or more consultation diagnosis is not covered in patient's benefits.<br />${instructionText}`;
                        } else if (!selectedCompanyBenefitToProceed.isProcedureCodeCovered) {
                            collectMessageAppendText = `One or more clinic procedure(s) is not covered in patient's benefits.<br />${instructionText}`;
                        }
                    } else {
                        collectMessageAppendText = selectedCompanyBenefitToProceed.remark;
                    }
                }
            }

            if (!this.isEditPrescription) {
                this.confirmMarkAsPaidMessage = counterCollectAmount > 0 ? `<p class="fs-1 text-danger">Please collect cash. <br /><span style="white-space: nowrap;"><b>RM ${counterCollectAmount ? counterCollectAmount.toFixed(2) : ''}</b></span></p>${collectMessageAppendText.length > 0 ? `Reason: ${collectMessageAppendText}` : ''}<hr /><p>Mark this payment as completed?</p><p>Please make sure that you have collected <b>ALL</b> the required payments.</p>` : '<p>Confirm this payment?</p><p class="text-danger">Employer covers 100% of the cost; no need for cash payment.</p>';
            } else {
                this.confirmMarkAsPaidMessage = counterCollectAmount > 0 ? `<p class="fs-1 text-danger">Please collect cash. <br /><span style="white-space: nowrap;"><b>RM ${counterCollectAmount ? counterCollectAmount.toFixed(2) : ''}</b></span></p>${collectMessageAppendText.length > 0 ? `Reason: ${collectMessageAppendText}` : ''}<hr /><p>You have pending changes for prescription!</p><p>Discard and proceed?</p>` : '<p>You have pending changes for prescription!</p><p>Discard and proceed?</p>';
            }

            this.$refs.popupCollectPayment.show();
        },
        confirmProceed () {
            this.isSubmittingCompletePayment = true;
            this.confirmMarkAsPaidMessage = '<p>Saving payment details...</p>';

            this.axios.post('Clinic/CompletePayment', {
                'cpi': this.clinicPaymentId,
                'seti': this.selectedEmployeeTierId,
                'cec': this.collectEmployeeCreditAmount
            }).then(() => {
                this.isSuccessSubmitCompletePayment = true;
                this.confirmMarkAsPaidMessage = '<p>Successful! Consultation has been marked as paid!</p>';
            }).catch(() => {
                this.isFailedCompletePayment = true;
                this.isSubmittingCompletePayment = false;
                this.confirmMarkAsPaidMessage = `<p>There's error completing the payment. Please review the payment details and try again.</p>`;

                this.getPaymentDetails();
            });
        },
        dismissConfirmPayment () {
            this.$refs.popupCollectPayment.hide();
        },
        redirectToPaymentPage () {
            this.$refs.popupCollectPayment.hide().then(() => {
                this.$router.push({
                    'name': 'clinic-consultation-list'
                });
            });
        },
        editPrescription () {
            this.isEditPrescription = true;
            this.oldPrescriptionList = _.cloneDeep(this.prescriptionList);
        },
        async savePrescription () {
            const valid = await this.validatePrescriptionValidDays();
            if (valid) {
                this.saveErrorMessage = null;
                this.isEditPrescription = false;

                // Display Pop Up
                this.$refs.savingPrescription.show();

                // Data massage
                let prescriptionList = [];
                prescriptionList = this.prescriptionList.map((item) => ({
                    'di': item.drugId,
                    'q': item.quantity,
                    'fd': item.consumptionFrequency,
                    'qc': item.quantityPerConsumption,
                    'si': null,
                    'sr': null
                }));

                let prescriptionDetails = prescriptionList.length === 0 ? null : {
                    'pl': prescriptionList,
                    'pvd': this.prescriptionValidDays,
                    'sr': this.prescriptionSpecialReminder
                };

                // Call API
                this.axios.post('Clinic/UpdatePaymentPrescription', {
                    'clinicPaymentId': this.clinicPaymentId,
                    'prescriptionDetails': prescriptionDetails
                }).then(({ data }) => {
                    setTimeout(() => {
                        this.$refs.savingPrescription.hide(() => {
                            this.getPaymentDetails();
                        });
                    }, 500);
                });
            } else {
                this.saveErrorMessage = 'Invalid Prescription Valid Days! Please check again.';
                this.$nextTick(() => {
                    let errorInput = document.querySelector('.is-invalid');

                    if (errorInput) {
                        errorInput.focus();
                    }
                });
            }
        },
        validatePrescriptionValidDays () {
            return this.$validator.validateAll('prescription-valid-days');
        },
        cancelEditPrescription () {
            this.prescriptionList = _.cloneDeep(this.oldPrescriptionList);
            this.oldPrescriptionList = [];
            this.isEditPrescription = false;
        },
        discardPrescriptionChanges () {
            this.prescriptionList = _.cloneDeep(this.oldPrescriptionList);
            this.isEditPrescription = false;
            this.confirmProceed();
        },
        viewPatientPastPrescriptions () {
            let route = this.$router.resolve({
                'name': 'clinic-past-prescriptions',
                'params': {
                    'patientId': this.collectPaymentDetails.patientId
                }
            });
            window.open(route.href, '_blank');
        }
    }
};
</script>

<style>
    .payment-detail {}

    .payment-detail .payment-detail-row .payment-detail-title {
            margin-bottom: .25rem;
        }

    @media(min-width: 576px) {
        .payment-detail .payment-detail-row {
            display: flex;
        }

        .payment-detail .payment-detail-row .payment-detail-title {
            width: 250px;
            margin-bottom: 0;
            margin-right: 1.25rem;
        }

        .payment-detail .payment-detail-row .payment-detail-content {
            display: flex;
            flex: 1;
        }

        .payment-detail .payment-detail-row .payment-detail-title.patient-payment-detail-title{
            width: 300px;
        }
    }

    .payment-detail .payment-detail-row:not(:last-child) {
        margin-bottom: 1.25rem;
    }

    .payment-detail-content p:last-child {
        margin-bottom: 0;
    }

</style>
